import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {IInstitutionSettingsRequest} from '../models/institution-settings.request.model';

@Injectable({
  providedIn: 'root',
})
export class InstitutionSettingsService {
  private readonly httpClient = inject(HttpClient);

  private readonly updateOrganizationUrl = `${environment.api.baseUrl}/${environment.Organization.updateOrganization}`;

  updateOrganization(request: IInstitutionSettingsRequest, id: number) {
    return this.httpClient.put(`${this.updateOrganizationUrl}/${id}`, request);
  }
}
